import type { RouteParamsGeneric, RouteRecordNormalized } from 'vue-router';

/**
 * Identity of what a `<router-view>` is showing: the route record it renders
 * plus the values of the path params that record declares.
 *
 * Most detail pages read their id from the route once, at setup. Vue Router
 * reuses the component when only a param changes, so going from student A to
 * student B (global search, a notification) changed the URL but left A on
 * screen, and Reset Password, ID card and CBT report then acted on A. Keying
 * the view by this value remounts it for another record. A query change (tabs)
 * or a move between the child routes of a nested layout (billing tabs) keeps
 * the same key, so those pages keep their state.
 */
export function routeViewKey(record: RouteRecordNormalized | undefined, params: RouteParamsGeneric): string {
  if (!record) return '';

  const names = [...record.path.matchAll(/:(\w+)/g)].map(match => match[1] as string);
  const values = names.map((name) => {
    const value = params[name];
    return `${name}=${Array.isArray(value) ? value.join('/') : (value ?? '')}`;
  });

  return [record.path, ...values].join('|');
}
